module.exports = __webpack_public_path__ + "media/images/icon-svg/edit-40cf7e1fa1c86e3a1f0d95fb2087d632.svg";